import { z } from 'zod';

import { osMessageResponseTypeSchema } from '@getvim/vim-os-api';

const messageResponseTypeSchema = osMessageResponseTypeSchema;

export const ErrorMessageResponseType = messageResponseTypeSchema.Enum;
export type ErrorMessageResponseType = z.infer<typeof messageResponseTypeSchema>;
